import { render, staticRenderFns } from "./UpdateAddress.vue?vue&type=template&id=37f3c280&"
import script from "./UpdateAddress.vue?vue&type=script&lang=js&"
export * from "./UpdateAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports